import React, { useEffect, useRef, useState, useMemo } from "react";
import ReactDOM from "react-dom";
import { useRouter } from "../../hooks/router";
import {
    add_channel_to_favourites,
    get_home,
    get_channels,
    set_advertisement_req,
    remove_channel_from_favourites,
} from "../../server/requests";
import { translateWord, decrypt } from "../../components/Util/util";

import '../../components/Pages/Player/IsProtected.scss'
import './LivePlayer.scss'

import Loading from "../../components/Loading/Loading";
import Hls from "hls.js";
import ErrorMessage from "../../components/AlertMessage/ErrorMessage";
import PremiumField from "../../components/pages_child/PremiumField/PremiumField";
import VerifyPIN from "../../components/SubUsers/VerifyPIN/VerifyPin";
import Controls from "./Controls";
import Modal from "../../components/Pages/Modal/Modal";


var time_out_percent
var time_out_control
var time_out_play_live
var time_out_ads

export default ({ network, archive, configs, isGuest }) => {
    const router = useRouter()
    const user = JSON.parse(decrypt('user', localStorage.getItem('user')))

    const refVideoPlayerLive = useRef()
    const refPlayerLive = useRef()

    const other_url_index = useRef(0)

    const [showArchive, setShowArchive] = useState('live')

    const [currentTime, setCurrentTime] = useState(0)
    const [duration, setDuration] = useState(0)
    const [valueProgress, setValProgress] = useState(0)
    const [valProgressNextEpisode, setValProgressNextEpisode] = useState(0)
    const [channels, setChannels] = useState([
        { id: 0, title: 'favourites', array: [] },
        { id: 1, title: 'all', array: [] },
    ])

    const [urlPlayer, setUrl] = useState('')
    const [activeMedia, setActiveMedia] = useState('')
    const [idActiveMedia, setIdActiveMedia] = useState(null)
    const [episode, setEpisode] = useState('')

    const [playPause, setPlayPause] = useState(false)
    const [fullScreen, setFullScreen] = useState(false)
    const [showLoading, setShowLoading] = useState(false)
    const [resume, setResume] = useState(false)
    const [audioTracks, setAudioTracks] = useState([])
    const [activeAudioTrack, setActiveAudioTrack] = useState({})
    const [subtitles, setSubtitles] = useState([])
    const [activeSub, setActiveSub] = useState({})
    const [classVideo, setClassVideo] = useState('')
    const [showMessage, setShowMessage] = useState(false)
    const [errMessageEpg, setErrMessageEpg] = useState('')
    const [showErrMessageEpg, setShowErrMessageEpg] = useState(false)
    const [showProtectedField, setShowProtectedField] = useState(false)
    const [activeAdvertisement, setActiveAdvertisement] = useState('')

    const [showAdvertisement, setShowAdvertisement] = useState(false)
    const [showPremium, setShowPremium] = useState({
        show: false,
        type: '',
        id: ''
    })
    const [hls, setHls] = useState(null)
    const [timeshift, setTimeshift] = useState(false)

    useEffect(() => {

        refVideoPlayerLive.current.addEventListener('ended', onEnded)
        refVideoPlayerLive.current.addEventListener('loadedmetadata', loadedMetaDataPlayer)

        setShowLoading(true)
        setShowArchive('live')

        get_channels({}, data => {

            let newArray = channels
            let active_channel

            if (router.query.id) {

                active_channel = data.find(el => el.id == router.query.id)

                if (!active_channel) active_channel = data[0]

                other_url_index.current = 0

            } else {

                if (localStorage.getItem('last_channel_id')) {

                    active_channel = data.find(el => el.id == localStorage.getItem('last_channel_id'))

                    if (!active_channel) active_channel = data[0]

                    localStorage.setItem('last_channel_id', active_channel.id)

                } else {

                    active_channel = data[0]
                    localStorage.setItem('last_channel_id', data[0].id)

                }
                // active_channel = data[i].content[0]

            }

            setActiveMedia(active_channel)


            if (!active_channel.canWatch) {
                setShowLoading(false)
                setShowPremium({
                    show: true,
                    id: active_channel.id,
                    type: 'live'
                })
                setShowProtectedField(false)
                localStorage.setItem('last_channel_id', router.query.id)
            } else if (active_channel.is_protected && (localStorage.getItem('disable_code') == 'true')) {
                setShowProtectedField(true)
            } else {
                setShowProtectedField(false)
                set_advertisement(active_channel)
                localStorage.setItem('last_channel_id', router.query.id)

            }
            newArray[1].array = data
            setShowLoading(false)

            setChannels([...newArray])

            router.push(`?id=${active_channel.id}`)

        }, err => { })

    }, [router.query.id])

    useEffect(() => {
        refVideoPlayerLive.current.addEventListener('timeupdate', timeUpdatePlayer)

        return () => refVideoPlayerLive?.current?.removeEventListener('timeupdate', timeUpdatePlayer)
    })

    useEffect(() => {
        document.addEventListener('keydown', keyDown)
        return () => document.removeEventListener('keydown', keyDown)
    }, [playPause, fullScreen]);

    useEffect(() => {
        if (archive) {
            clearTimeout(time_out_ads)
            let _channel = channels[1].array.find(e => e.id == router.query.id)

            if (_channel?.archived_channel?.type == "flussonic") {
                let _duretion = archive.stop_ut - archive.start_ut
                // var duration = epg.stopUX - epg.startUX;
                var url = `${_channel.archived_channel.url}/index-${archive.start_ut}-${_duretion}.m3u8`;
                // return url;
                playerVideo(url)
                setTimeshift(true)
                setShowArchive('archive')

            } else {
                if (_channel.archived_channel_host) {
                    let start = archive.start_ut
                    let end = archive.stop_ut

                    let url = `http://${_channel.archived_channel_host}/archive/${_channel.id}/index.m3u8?start=${start}&duration=${end - start}`
                    playerVideo(url)
                    setTimeshift(true)
                    setShowArchive('archive')

                } else {
                    //Archive
                    setShowErrMessageEpg(true)
                    hide_error_message()
                }
            }


        }
    }, [archive])

    const set_advertisement = (channel) => {
        //;
        if (channel.advertisements.length) {

            let length = channel.advertisements.length - 1
            let random_ads = Math.floor(Math.random() * length)

            let body = {
                advertisement_id: channel.advertisements[random_ads].id,
                channel_id: channel.id,
                status: 'start',
            }

            setActiveAdvertisement({ ...channel.advertisements[random_ads] })
            set_advertisement_req('channel', body, res => { done() }, err => { console.log(err, 'error advertisment') })

            const done = () => {
                document.body.classList.add('advertisement')
                document.body.id = channel.advertisements[random_ads].id
                setUrl(channel.url)
                setShowAdvertisement(true)
                playerVideo(channel.advertisements[random_ads].url)
            }

            clearTimeout(time_out_ads)

            time_out_ads = setTimeout(() => {
                set_advertisement(channel)
            }, 1800000);

        } else {
            playerVideo(channel.url)
            setShowAdvertisement(false)
            document.body.classList.remove('advertisement')

        }
    }

    const playerVideo = (url) => {

        if (Hls.isSupported()) {

            if (hls) hls.destroy();
            let _hls = new Hls();

            setHls(_hls)

            _hls.loadSource(url);
            _hls.attachMedia(refVideoPlayerLive.current);

            _hls.on(Hls.Events.AUDIO_TRACK_LOADED, function (err, data) {
                setAudioTracks(_hls.audioTracks);
            })
            _hls.on(Hls.Events.AUDIO_TRACK_SWITCHED, function (e, data) {
                setActiveAudioTrack(_hls.audioTrack);
            });

            _hls.on(Hls.Events.SUBTITLE_TRACK_LOADED, function (e, data) {
                setSubtitles(_hls.subtitleTracks);
            });

            _hls.on(Hls.Events.SUBTITLE_TRACK_SWITCH, function (e, data) {
                setActiveSub(_hls.subtitleTrack);
            });

            refVideoPlayerLive.current.onerror = () => {
                console.log('error videooooooooo')
            }
            // if(activeMedia){
            _hls.on(Hls.Events.ERROR, function (err, data) {
                if (data && data.fatal) {
                    if (showArchive == 'live') {

                        let active_channel = channels[1].array.find(el => el.id == router.query.id)

                        if (active_channel.channel_urls.length) {
                            if (active_channel.channel_urls[other_url_index.current]) {
                                playerVideo(active_channel.channel_urls[other_url_index.current].url)
                                other_url_index.current++
                            } else {
                                other_url_index.current = 0
                                videoError()
                            }


                        } else {
                            videoError()
                        }
                    } else {
                        videoError()
                    }

                }
            });
            // }


            // videoError.hide()
            // hls.on(Hls.Events.MANIFEST_PARSED, function () {

            // });
        }

        function videoError() {
            clearTimeout(time_out_play_live)
            time_out_play_live = setTimeout(() => {
                setShowMessage(true)
                if (router.query.id) {
                    if (router.history.location.pathname == '/player') router.history.goBack()
                    // else router.push(router.history.location.pathname)
                }

                hide_error_message()

            }, 3000)
        }
    }

    const onEnded = () => {

        if (document.body.className.indexOf('advertisement') != -1) {
            let body = {
                advertisement_id: document.body.id,
                channel_id: router.query.id,
                status: 'end',
            }


            set_advertisement_req('channel', body, res => { }, err => { console.log(err, 'error advertisment') })

        }
        document.body.classList.remove('advertisement')
        setShowAdvertisement(false)
        playerVideo(urlPlayer)

    }

    const loadedMetaDataPlayer = () => {
        localStorage.removeItem('begin')
        setShowLoading(false)
        window.onresize = resize
    }

    const resize = (e) => {
        if (!document.webkitIsFullScreen) {
            document.body.classList.remove('full_screen_body')
            setFullScreen(false)
        }
    }

    const timeUpdatePlayer = () => {

        clearTimeout(time_out_play_live)

        if (refVideoPlayerLive.current && refVideoPlayerLive.current.currentTime > 0) {

            try {

                if (resume) {
                    refVideoPlayerLive.current.currentTime = currentTime
                    setResume(false)
                }

                if (currentTime !== Math.round(refVideoPlayerLive.current.currentTime)) {
                    if (duration - currentTime < 60) {
                        let x = duration - 60
                        if (((currentTime - x) / 60) * 100 <= 100) {
                            setValProgressNextEpisode(((currentTime - x) / 60) * 100)
                        }
                    }

                    setDuration(Math.round(refVideoPlayerLive.current.duration))
                    setCurrentTime(Math.round(refVideoPlayerLive.current.currentTime))
                }
                if (duration != 0) {
                    let percent = (currentTime / duration) * 100
                    setValProgress(percent)
                }
            } catch (e) {
            }
        }
    }

    const keyDown = (e) => {

        if (e.code === 'Space') btn_play_pause()

        else if (e.code === 'KeyF') btn_full_screen()

    }

    const change_handle_range = (e) => {

        setValProgress(e.target.value)
        refVideoPlayerLive.current.pause()

        let _current_time = Math.round(e.target.value) / 100 * duration

        clearTimeout(time_out_percent)

        time_out_percent = setTimeout(() => {

            refVideoPlayerLive.current.currentTime = _current_time
            refVideoPlayerLive.current.play()

        }, 700)

    }

    const btn_full_screen = () => {
        if (fullScreen === false) {
            full_screen()
            document.body.classList.add('full_screen_body')
        } else {
            document.body.classList.remove('full_screen_body')
            exit_full_screen()
        }

        setFullScreen(!fullScreen)
    }

    const full_screen = () => {
        if (refPlayerLive.current.requestFullscreen) {
            refPlayerLive.current.requestFullscreen();
        } else if (refPlayerLive.current.webkitRequestFullscreen) { /* Safari */
            refPlayerLive.current.webkitRequestFullscreen();
        } else if (refPlayerLive.current.msRequestFullscreen) { /* IE11 */
            refPlayerLive.current.msRequestFullscreen();
        }
    }

    const exit_full_screen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }

    }

    const btn_play_pause = () => {
        document.removeEventListener('keydown', keyDown)

        if (!playPause) document.getElementById('video_player_live').pause()

        else document.getElementById('video_player_live').play()

        setPlayPause(!playPause)

    }

    const btn_back_forward = () => {
        if (refVideoPlayerLive.current.currentTime < 10) {
            setCurrentTime(0)
            refVideoPlayerLive.current.currentTime = 0
        } else {
            var percent
            var cur = refVideoPlayerLive.current.currentTime

            percent = Math.round(currentTime / duration * 100);
            setValProgress(percent)
            setCurrentTime(prev => prev - 10)
            refVideoPlayerLive.current.currentTime = cur - 10
        }
    }

    const btn_forward = () => {
        if (refVideoPlayerLive.current.duration - refVideoPlayerLive.current.currentTime < 10) {
            setCurrentTime(Math.round(refVideoPlayerLive.current.duration))
            refVideoPlayerLive.current.currentTime = refVideoPlayerLive.current.duration
        } else {
            var percent
            var cur = refVideoPlayerLive.current.currentTime

            percent = Math.round(currentTime / duration * 100);
            setValProgress(percent)
            setCurrentTime(prev => prev + 10)
            refVideoPlayerLive.current.currentTime = cur + 10
        }
    }

    const mouse_movie_video = () => {
        if (!classVideo) {
            setClassVideo('show_control')
            hide_cursor_mouse()
        }
    }


    const hide_cursor_mouse = () => {
        document.getElementById('controls_live').addEventListener("mouseover", e => {
            setTimeout(function () {
                document.body.style.cursor = "none";
                window.addEventListener("mousemove", et => {
                    document.body.style.cursor = "default";
                });
            }, 3000);
        });
    }

    const mouse_move_controls = () => {
        if (!classVideo) {
            setClassVideo('show_control')
            hide_cursor_mouse()
        }
        clearTimeout(time_out_control)

        time_out_control = setTimeout(() => {
            setClassVideo('')
        }, 3000)
    }

    const btn_next_channel = () => {
        let active_channel = channels[1].array.find(e => e.id == router.query.id)
        let next_live
        if ((channels[1].array.indexOf(active_channel) + 1) != channels[1].array.length) {
            next_live = channels[1].array[channels[1].array.indexOf(active_channel) + 1]
        } else {
            next_live = channels[1].array[0]
        }
        setPlayPause(false)
        setShowArchive('live')

        router.push('?id=' + next_live.id)
    }

    const btn_previous_channel = () => {
        let active_channel = channels[1].array.find(e => e.id == router.query.id)
        let prev_live
        if ((channels[1].array.indexOf(active_channel) - 1) < 0) {
            prev_live = channels[1].array[channels[1].array.length - 1]
        } else {
            prev_live = channels[1].array[channels[1].array.indexOf(active_channel) - 1]
        }
        setPlayPause(false)
        setShowArchive('live')

        router.push('?id=' + prev_live.id)
    }

    const show_live_btn = () => {
        clearTimeout(time_out_ads)
        setTimeshift(false)
        setShowArchive('live')
        playerVideo(activeMedia.url)
    }

    const show_time_shift = () => {
        clearTimeout(time_out_ads)
        if (activeMedia?.archived_channel?.type == "flussonic") {

            var now = new Date;

            var utc_timestamp = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
                now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());

            var x = Math.round(utc_timestamp / 1000) - 3600

            let url = `${activeMedia.archived_channel.url}/index-${x}-now.m3u8`;

            playerVideo(url)
            setTimeshift(!timeshift)
            setShowArchive('timeshift')
        } else {
            if (activeMedia.archived_channel_host) {
                const _url = `http://${activeMedia.archived_channel_host}/timeshift/${activeMedia.id}/index.m3u8`

                playerVideo(_url)
                setTimeshift(!timeshift)
                setShowArchive('timeshift')
            } else {
                //timeshift not found
                setShowErrMessageEpg(true)
                hide_error_message()
            }
        }

    }

    const hide_error_message = () => {
        setTimeout(() => {
            setShowMessage(false)
            setShowErrMessageEpg(false)
        }, 3000)
    }

    const callBackIsProtected = (id) => {
        let active_live = channels[1].array.find(e => e.id == router.query.id)
        localStorage.setItem('last_channel_id', router.query.id)

        playerVideo(active_live.url)
    }

    return (
        <>

            <div id="player_live" ref={refPlayerLive} className={classVideo}>
                <ErrorMessage
                    text={'Live stream is not available now. please try after few minutes'}
                    type={'warning'}
                    show={showErrMessageEpg}
                />

                <ErrorMessage
                    text={'Live stream is not available now. please try after few minutes'}
                    type={'error'}
                    show={showMessage}
                />
                {showProtectedField ?
                    <div className="is_protected_field bg_color">
                        <VerifyPIN user={user} callBackIsProtected={callBackIsProtected}
                            setShowProtectedField={setShowProtectedField} />
                    </div>
                    : null}
                {showPremium.show ?
                    isGuest ?
                        ReactDOM.createPortal(
                            <Modal
                                btnConfirm={() => {
                                    localStorage.setItem('showLogin', true)
                                    router.push('/auth')
                                }}
                                btnCancel={() => {
                                    router.history.goBack()
                                    setShowPremium({
                                        show: false,
                                        id: '',
                                        type: ''
                                    })
                                }}
                                btnConfirmText={translateWord('Sign in')}
                                btnCancelText={translateWord('Cancel')}
                                title={translateWord('Sign in to continue')}
                            />, document.body)
                        :
                        ReactDOM.createPortal(<PremiumField
                            content_type='live'
                            configs={configs}
                            id={showPremium.id}
                            type={showPremium.type}
                            close={() => {
                                router.push(`/settings?a=payment&content_id=${showPremium.id}`)
                                setShowPremium({
                                    show: false,
                                    id: '',
                                    type: ''
                                })
                            }}
                        />, document.body)

                    : null}
                <div id="controls_live" onMouseMove={mouse_move_controls} onDoubleClick={btn_full_screen}>

                    {
                        showLoading ?
                            <Loading /> :
                            network && fullScreen ?
                                <div className="errorConnectionPlayer">
                                    <h2>Error</h2>
                                    <h1>Your device may not connected to the Internet.Please make sure your
                                        connection is working.</h1>
                                </div>
                                :
                                showAdvertisement ? null : <Controls
                                    show_live_btn={show_live_btn}
                                    btn_back_forward={btn_back_forward}
                                    btn_forward={btn_forward}
                                    currentTime={currentTime}
                                    duration={duration}
                                    showArchive={showArchive}
                                    active_channel={activeMedia}
                                    show_time_shift={show_time_shift}
                                    playPause={playPause}
                                    btn_play_pause={btn_play_pause}
                                    btn_next_channel={btn_next_channel}
                                    btn_previous_channel={btn_previous_channel}
                                    change_handle_range={change_handle_range}
                                    valueProgress={valueProgress}
                                    btn_full_screen={btn_full_screen}
                                />

                    }
                </div>
                <video
                    autoPlay
                    onMouseMove={mouse_movie_video}
                    id={'video_player_live'}
                    ref={refVideoPlayerLive}
                    onDoubleClick={btn_full_screen}
                ></video>
            </div>
        </>
    )
}